import { BrowserRouter } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import AppRouter from './routes/AppRouter';
import SessionExpiredModal from './components/SessionExpireModal/SessionExpireModal';
import SplashScreen from './components/SplashScreen/SplashScreen';
import ToastContainer from './components/Toast/ToastContainer';
import { ToastProvider } from './context/ToastContext';
import useSessionManager from './hooks/useSessionManager';
import { setAuth } from './store/slices/authSlice';
import { useAppDispatch } from './store/hooks';

const App = () => {
  const { isSessionExpired, closeModal } = useSessionManager();
  const [showSplash, setShowSplash] = useState(false);
    const dispatch = useAppDispatch();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        dispatch(setAuth(JSON.parse(user)));
      } catch {
        localStorage.removeItem('user');
      }
    }
  }, [dispatch]);

  useEffect(() => {
    // if (!isFirstMount.current) return;
    // isFirstMount.current = false;

    const justLoggedIn = localStorage.getItem('justLoggedIn');
    const loginTimestamp = parseInt(justLoggedIn, 10);

    if (justLoggedIn && Date.now() - loginTimestamp < 5000) {
      setShowSplash(true);
    }

    localStorage.removeItem('justLoggedIn');
  }, []);

  const wasIntentionalLogout = localStorage.getItem('intentionalLogout') === 'true';
  const shouldShowSessionModal = isSessionExpired && !wasIntentionalLogout;

  return (
    <BrowserRouter>
      <ToastProvider>
        <AppRouter />
        <ToastContainer />
        {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
        <SessionExpiredModal
          isOpen={shouldShowSessionModal}
          onClose={closeModal}
        />
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;